import { Box, useTheme } from "@mui/material";
import DataGrid, {
  FilterRow,
  HeaderFilter,
  Selection,
  Column,
  SortByGroupSummaryInfo,
  ColumnFixing,
  ColumnChooser,
  LoadPanel,
  Summary,
  GroupItem,
  TotalItem,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import Button from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";

import React, { useState, useRef, useEffect } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { DataGridConfig } from "../../../config";

import FilterBox from "./filter";
import {
  getViolationAanTypeReportFun,
  setFilter,
} from "../../../store/reducers/report";
import moment from "moment";

const ViolationAanTypeReportList = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const getViolationAanTypeReportData = useSelector(
    (state) => state.report.violationAanTypeReportData
  );
  const filter = useSelector((state) => state.report.filter);
  const [showFilterRow, setShowFilterRow] = useState(true);
  const [showHeaderFilter, setShowHeaderFilter] = useState(true);
  const [currentFilter, setCurrentFilter] = useState("full");
  const [isType, setIsType] = useState(1);
  const [isPop, setIsPop] = useState(false);
  const [selectIndex, setSelectIndex] = useState(-1);
  const logedUser = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState([]);

  const [formEditData, setFormEditData] = useState("");
  const [isConfirm, setIsConfirm] = useState(false);
  const setFilters = (field, value) => {
    //console.log(field, value);
    dispatch(setFilter({ ...filter, [field]: value }));
  };
  // useEffect(() => {
  //   //console.log(Object.keys(filter).length);
  //   if (Object.keys(filter).length === 0) {
  //     dispatch(setFilter({ date_type: "year" }));
  //     //  dispatch(getPorkurorReportData(filter));
  //   }
  // }, [filter, dispatch]);
  useEffect(() => {
    // gridRef.current.instance.beginCustomLoading();
    if (getViolationAanTypeReportData == null) {
      dispatch(
        getViolationAanTypeReportFun({
          ...filter,
          start_date: moment().startOf("month").format("YYYY-MM-DD"),

          end_date: moment().subtract(0, "days").format("YYYY-M-D"),
        })
      );
    } else {
      // gridRef.current.instance.endCustomLoading();
      setFormData(getViolationAanTypeReportData);
      // dispatch(setRemFilter());
    }
  }, [getViolationAanTypeReportData, filter, dispatch]);
  // useEffect(() => {
  //   if (getPorkurorReportData == null && Object.keys(filter).length > 0) {
  //     dispatch(getPorkurorReportFun(filter));
  //   }
  // }, [getPorkurorReportData, filter, dispatch]);
  //console.log(getInspectorReportData);

  useEffect(() => {
    //console.log(Object.keys(filter).length);
    if (Object.keys(filter).length > 0) {
      dispatch(getViolationAanTypeReportFun(filter));
    }
  }, [filter, dispatch]);

  //console.log(props);
  // useEffect(() => {
  //   gridRef.current.instance.beginCustomLoading();
  //   if (props.porkurorReportListData) {
  //     setFormData(props.porkurorReportListData);
  //     gridRef.current.instance.endCustomLoading();
  //   }
  // }, [props]);
  // console.log(props.feedBackListData);
  const gridRef = useRef();

  const allowedPageSizes = [5, 10, , 30, 50, 100, "Бүгд"];

  // const onSelectionChanged = ({ selectedRowKeys, selectedRowsData }) => {
  //   // console.log("selectedRowKeys");
  //   // console.log(selectedRowsData[0].id);
  //   setSelectIndex(selectedRowKeys[0]);
  //   setIsType(2);
  //   setFormEditData(selectedRowsData[0]);
  // };
  const hideInfo = () => {
    setIsPop(false);
    setIsConfirm(false);
  };

  function deleteRecords() {
    selectIndex.forEach((key) => {
      gridRef.current.instance.deleteRow(key);
    });
  }
  function closeIsPop() {
    setIsPop(false);
  }
  function customizeDate(data) {
    return `Нийт дүн`;
  }
  console.log(filter);
  // console.log(formData);
  return (
    <>
      {/* <Box id="descContainer">dsdsvdsvs</Box> */}
      <Toolbar style={{ paddingBottom: "10px" }}>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <FilterBox getFilters={setFilters} />
          </Box>
        </Item>
      </Toolbar>
      <Toolbar>
        <Item location="before">
          <Box sx={{ ml: 2 }}>
            <Button
              icon={"refresh"}
              onClick={() => {
                dispatch(getViolationAanTypeReportFun(filter));
                gridRef.current.instance.refresh();
              }}
              type={"normal"}
              text="Сэргээх"
            />
          </Box>
        </Item>

        <Item location="after">
          <Box>
            <Button
              onClick={() => {
                gridRef.current.instance.exportToExcel();
              }}
            >
              <Box sx={{ background: "#fff", p: 0.5 }}>
                <img src="/assets/excel.png" alt="" className="dx-icon" />
              </Box>
            </Button>
          </Box>
        </Item>
      </Toolbar>

      <DataGrid
        ref={gridRef}
        {...DataGridConfig}
        remoteOperations={false}
        dataSource={formData}
        wordWrapEnabled={true}
        //keyExpr="id"
        //  keyExpr="violation_date"
        id="gridContainer"
        height={600}
      >
        <Selection mode="multiple" />
        <ColumnChooser enabled={false} />
        <ColumnFixing enabled={true} />

        {/* <Column
          allowSorting={true}
          caption="#"
          cellRender={(e) => {
            return e.rowIndex - 1 + 1;
          }}
          fixed={true}
        /> */}
        <Column dataField="offender_type" caption={"Субъект"} fixed={true} />
        <Column dataField="violation_date" caption={"Огноо"} groupIndex={0} />
        <Column dataField="company_name" caption={"Нэр"} groupIndex={1} />

        <Column
          dataField="total_violation"
          caption={"Нийт"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_6"
          caption={"Ая тухтай зорчих нөхцөлийг хангаагүй"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_9"
          caption={"Бэлэн мөнгө авсан"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_10"
          caption={"Журам зөрчсөн"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_11"
          caption={"Зогсоолд зогсоогүй."}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_12"
          caption={"Зогсоолоос хүн суулгаагүй"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_13"
          caption={"Зогсоолын бус газар хүн буулгасан."}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_14"
          caption={"Зогсоолын бус газар хүн буулгасан."}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_15"
          caption={"Мэргэшсэн үнэмлэхгүй"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_17"
          caption={"Өглөө эх авалт тасалсан"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_18"
          caption={"СОС дараагүй"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_19"
          caption={"Тамхи татсан"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_20"
          caption={"Техникийн бүрэн байдал дутуу"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_21"
          caption={"Утаатай тээврийн хэрэгсэл ашигласан"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_22"
          caption={"Хөдөлгөөний аюулгүй байдал хангаагүй"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_23"
          caption={"Хөлс төлөөгүй"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_25"
          caption={"Хууль бусаар тээвэрлэсэн"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_26"
          caption={"Хэл амаар доромжилсон"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_28"
          caption={"Цагийн хуваарь мөрдөөгүй"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_29"
          caption={"Цэвэрлэгээ хийгдээгүй"}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_30"
          caption={"Чиглэл маршрут зөрчсөн."}
          dataType="number"
          width={100}
        />
        <Column
          dataField="type_31"
          caption={"Шаардлага биелүүлээгүй"}
          dataType="number"
          width={100}
        />

        <Paging defaultPageSize={50} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={[20, 50, 100, 200, 500, 1000]}
          showNavigationButtons={true}
          showInfo={true}
        />
        <FilterRow visible={showFilterRow} applyFilter={currentFilter} />
        <HeaderFilter visible={showHeaderFilter} />

        <LoadPanel enabled={true} />

        <Summary>
          <GroupItem
            column="offender_type"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="Нийт"
          />
          <GroupItem
            column="total_violation"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat=" {0}"
          />
          <GroupItem
            column="type_6"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_9"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_10"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_11"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_12"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_13"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_14"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_15"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_17"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_18"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_19"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_20"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_21"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_22"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_23"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_25"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_26"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_28"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_29"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_30"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <GroupItem
            column="type_31"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />

          <TotalItem
            column="offender_type"
            summaryType="sum"
            // valueFormat="currency"
            customizeText={customizeDate}
          />
          <TotalItem
            column="total_violation"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat=" {0}"
          />
          <TotalItem
            column="type_6"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_9"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_10"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_11"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_12"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_13"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_14"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_15"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_17"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_18"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_19"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_20"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_21"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_22"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_23"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_25"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_26"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_28"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_29"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_30"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
          <TotalItem
            column="type_31"
            summaryType="sum"
            showInGroupFooter={true}
            alignByColumn={true}
            displayFormat="{0}"
          />
        </Summary>
        <SortByGroupSummaryInfo summaryItem={0} />
      </DataGrid>
    </>
  );
};

export default ViolationAanTypeReportList;
